(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["shop-the-look"] && !window.DesignMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const shopTheLookDots = document.querySelectorAll('.ShopTheLook__Inner .ShopTheLook__Dot');

  shopTheLookDots.forEach(dot => {
    dot.addEventListener('click', () => {
      if (dot.classList.contains('is-active')) {
        dot.classList.remove('is-active');
      } else {
        dot.parentNode.querySelectorAll('.ShopTheLook__Inner .ShopTheLook__Dot').forEach(child => child.classList.remove('is-active'));
        dot.classList.add('is-active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopthelook-grid"] && !window.DesignMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const shopTheLookDots = document.querySelectorAll('.ShopTheLook__Inner .ShopTheLook__Dot');

  shopTheLookDots.forEach(dot => {
    dot.addEventListener('click', () => {
      if (dot.classList.contains('is-active')) {
        dot.classList.remove('is-active');
      } else {
        dot.parentNode.querySelectorAll('.ShopTheLook__Inner .ShopTheLook__Dot').forEach(child => child.classList.remove('is-active'));
        dot.classList.add('is-active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
      })();
